import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useLanguage } from '../../assets/js/LanguageContext';
import '../../assets/styles/TokenStatusNotification.css';

const TokenStatusNotification = () => {
    const { isAuthenticated } = useAuth();
    const { t } = useLanguage();
    const [showWarning, setShowWarning] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);

    useEffect(() => {
        if (!isAuthenticated) return;

        const checkTokenStatus = () => {
            const token = localStorage.getItem('token');
            if (!token) return;

            try {
                const payload = JSON.parse(atob(token.split('.')[1]));
                const now = Date.now() / 1000;
                const timeUntilExpiry = payload.exp - now;
                
                if (timeUntilExpiry < 300) { // 5 minutos
                    setShowWarning(true);
                    setTimeLeft(Math.floor(timeUntilExpiry / 60));
                } else {
                    setShowWarning(false);
                }
            } catch (error) {
                console.error('Error al verificar token:', error);
            }
        };

        checkTokenStatus();
        const interval = setInterval(checkTokenStatus, 30000); // Verificar cada 30 segundos

        return () => clearInterval(interval);
    }, [isAuthenticated]);

    if (!showWarning) return null;

    return (
        <div className="token-status-notification">
            <div className="notification-content">
                <div className="notification-icon">⚠️</div>
                <div className="notification-text">
                    <strong>{t('session_expiring').replace('{min}', timeLeft)}</strong>
                    <p>{t('session_expiring_hint')}</p>
                </div>
                <button
                    type="button"
                    className="notification-close"
                    aria-label={t('session_expiring_close')}
                    onClick={() => setShowWarning(false)}
                >
                    ×
                </button>
            </div>
        </div>
    );
};

export default TokenStatusNotification;

